'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation for the showing shock waves from a live microphone.
 */
export function MicrophoneLiveAnimation(props: IAnimationProps) {
  const loadAnimation = () => import('../raw-json/microphone-live.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="MicrophoneLiveAnimation"
    />
  );
}
